import { clsx } from "clsx";
import { Icon } from "lucide-react";
import {
  BaseHTMLAttributes,
  ComponentProps,
  ReactElement,
  SyntheticEvent,
} from "react";
import { EntityImage } from "./entity-image";

interface MenuItemProps extends Pick<BaseHTMLAttributes<HTMLDivElement>, 'className'> {
    readonly label?: string;
    readonly icon?: ReactElement<typeof Icon>;
    readonly image?: ComponentProps<typeof EntityImage>;
    readonly onClick?: (event: SyntheticEvent) => void;
    readonly size?: 'S' | 'M' | 'L';
}

const MenuItem: React.FC<MenuItemProps> = ({ icon, image, label, onClick, size, className }) => {
    const IconComponent = icon?.type;
    return (
        <div className={clsx('prose-caption-12-medium relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-foreground/10 focus:text-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-foreground/5', className)} onClick={onClick}>
            {IconComponent ? <IconComponent size={
            size === 'S' ? 16 : 
            size === 'M' ? 24 : 
            size === 'L' ? 32 : 16
        }  {...icon.props} /> : image && <EntityImage {...image} /> }
            {label}
        </div>
    );
};

export { MenuItem };